/* eslint-disable no-case-declarations */

import APP from 'desktop/epgTypes';

const initialState = {
  activePrograms: {},
  currentProgram: null,
  playingProgram: null,
  currentChannelProgramsList: [],
  currentChannelProgramsMap: {},
  isExtendedProgramList: false,
};

export default (state = initialState, { type, payload }) => {
  let programsList;
  let programsMap;
  switch (type) {
    case APP.EVENT_CURRENT_PROGRAM_LIST_UPDATED:
      [programsMap, programsList] = processCurrentChannelProgram(payload.data.programs);
      return {
        ...state,
        currentChannelProgramsList: programsList,
        currentChannelProgramsMap: programsMap,
        isExtendedProgramList: payload.data.hasExtendedProgram,
      };
    case APP.EVENT_CURRENT_PROGRAM_CHANGED:
      return { ...state, currentProgram: payload.data };

    case APP.EVENT_PROGRAMS_READY:
    case APP.EVENT_CHANNELS_READY:
      const activePrograms = {};
      const { channels } = payload;
      Object.keys(channels).forEach((id) => {
        activePrograms[id] = channels[id].currentProgram;
      });
      return {
        ...state,
        activePrograms,
      };
    case APP.EVENT_ACTIVE_PROGRAM_CHANGED:
      return {
        ...state,
        activePrograms: {
          ...state.activePrograms,
          [payload.data.id]: payload.data.currentProgram,
        },
      };

    case APP.EVENT_CURRENT_CHANNEL_CHANGED:
      [programsMap, programsList] = processCurrentChannelProgram(payload.data.programs);
      return {
        ...state,
        currentChannelProgramsList: programsList,
        currentChannelProgramsMap: programsMap,
        isExtendedProgramList: payload.data.hasExtendedProgram,
      };

    case APP.EVENT_PLAYING_PROGRAM_CHANGED:
      return { ...state, playing: payload.data };

    default:
      return state;
  }
};

function processCurrentChannelProgram(programs) {
  const programsMap = {};
  const programsList = [];
  programs.forEach((program) => {
    programsMap[program.startTimestamp] = program;
    programsList.push(program.startTimestamp);
  });

  return [programsMap, programsList];
}
